// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IJavaBlockTypeData {
  source: string | undefined;
  name: string;
  id: number;
  data: number;
}
